var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c(
            "search-item",
            {
              attrs: {
                "config-module": "515",
                "show-simple": false,
                "expand-adv": true,
                "custom-search-items": _vm.customSearchItems
              },
              on: {
                advSearchItemCallBack: _vm.toAdvancedQuery,
                preProcessSearchItem: _vm.toPreProcessSearchItem
              }
            },
            [
              _c(
                "template",
                { slot: "operations" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["button_VoucherMaintenance_generateVoucher"],
                          expression:
                            "['button_VoucherMaintenance_generateVoucher']"
                        }
                      ],
                      attrs: {
                        no: "CreateVoucher",
                        type: "primary",
                        plain: ""
                      },
                      on: { click: _vm.generateHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CreateVoucher")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["button_VoucherMaintenance_deleteVoucher"],
                          expression:
                            "['button_VoucherMaintenance_deleteVoucher']"
                        }
                      ],
                      attrs: {
                        no: "DeleteVoucher",
                        type: "primary",
                        plain: ""
                      },
                      on: { click: _vm.deleteHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DeleteVoucher")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["button_VoucherMaintenance_forceDeletion"],
                          expression:
                            "['button_VoucherMaintenance_forceDeletion']"
                        }
                      ],
                      attrs: { no: "ForceDelete", type: "primary", plain: "" },
                      on: { click: _vm.forceDeleteClickHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ForceDelete")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["button_VoucherMaintenance_auditVoucher"],
                          expression:
                            "['button_VoucherMaintenance_auditVoucher']"
                        }
                      ],
                      attrs: {
                        no: "ReviewVoucher",
                        type: "primary",
                        plain: ""
                      },
                      on: { click: _vm.verifyHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ReviewVoucher")))]
                  ),
                  _vm.isJDCLOUD
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            no: "KingdeeCloudApprove",
                            type: "primary",
                            plain: ""
                          },
                          on: { click: _vm.cloudVerifyHandler }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_KingdeeCloudApprove"))
                          )
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["button_VoucherMaintenance_cancelReview"],
                          expression:
                            "['button_VoucherMaintenance_cancelReview']"
                        }
                      ],
                      attrs: { no: "CancelAudit", type: "primary", plain: "" },
                      on: { click: _vm.cancelVerifyHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CancelAudit")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: [
                            "button_VoucherMaintenance_exportCredentials"
                          ],
                          expression:
                            "['button_VoucherMaintenance_exportCredentials']"
                        }
                      ],
                      attrs: {
                        no: "ExportVoucher",
                        type: "primary",
                        plain: ""
                      },
                      on: { click: _vm.exportHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ExportVoucher")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["button_VoucherMaintenance_redOffsetVoucher"],
                          expression:
                            "['button_VoucherMaintenance_redOffsetVoucher']"
                        }
                      ],
                      attrs: {
                        no: "WriteBackVoucher",
                        type: "primary",
                        plain: ""
                      },
                      on: { click: _vm.reverseHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_WriteBackVoucher")))]
                  ),
                  _vm.yyTcloud
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            no: "SyncTargetDocumentNo",
                            type: "primary",
                            plain: ""
                          },
                          on: { click: _vm.SyncTargetDocumentNoHandler }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("CargoMsg.Cargo_SyncTargetDocumentNo")
                            )
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.yyTcloud
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            no: "RefreshTcloudToken",
                            type: "primary",
                            plain: ""
                          },
                          on: { click: _vm.RefreshTcloudTokenHandler }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_RefreshTcloudToken"))
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "section grid-wrapper" },
            [
              _c("cargo-ag-grid", {
                attrs: {
                  "config-module": "6000002",
                  "grid-params": _vm.gridParams,
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.gridParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.gridParams = $event
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "pagination-wrapper",
              attrs: { id: "footer-wrapper" }
            },
            [
              _c("cargo-pagination", {
                attrs: {
                  "config-module": "6000002",
                  total: _vm.searchConditions.total,
                  page: _vm.searchConditions.pageNum,
                  limit: _vm.searchConditions.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.searchConditions, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.searchConditions, "pageSize", $event)
                  },
                  pagination: function($event) {
                    return _vm.searchHandler(true)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.accountingEntryWindow.visible
        ? _c("accounting-entry-window", {
            ref: "accountingEntryWindow",
            attrs: {
              visible: _vm.accountingEntryWindow.visible,
              "is-ext": _vm.isExt,
              "prefix-data-provider": _vm.prefixDataProvider,
              "account-title-data-provider": _vm.accountTitleDataProvider,
              "mapping-departments": _vm.mappingDepartments,
              "mapping-staffs": _vm.mappingStaffs,
              voucher: _vm.accountingEntryWindow.rowData,
              index: _vm.accountingEntryWindow.index,
              "account-set": _vm.accountSet,
              check: _vm.activeEditVoucherVerification,
              "check-department": _vm.checkDepartmentAccountingItem
            },
            on: {
              close: function() {
                return (_vm.accountingEntryWindow.visible = false)
              },
              updateTargetDocumentNo: _vm.updateTargetDocumentNo,
              updateAudit: _vm.updateAudit
            }
          })
        : _vm._e(),
      _c("query-window", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.queryWindowDialog.visible,
            expression: "queryWindowDialog.visible"
          }
        ],
        ref: "queryWindow",
        attrs: {
          visible: _vm.queryWindowDialog.visible,
          "is-ext": _vm.isExt,
          "account-set": _vm.accountSet,
          "pre-bank-slip-states": _vm.preBankSlipStates,
          source: "VoucherList"
        },
        on: {
          batchGenerate: function($event) {
            return _vm.commitHandler("batchGenerate")
          },
          commit: function($event) {
            return _vm.commitHandler("commit")
          },
          groupCommit: function($event) {
            return _vm.commitHandler("groupCommit")
          },
          close: function() {
            return (_vm.queryWindowDialog.visible = false)
          }
        }
      }),
      _vm.dateSelecterDialog.visible
        ? _c("date-selector", {
            ref: "dateSelecter",
            attrs: {
              visible: _vm.dateSelecterDialog.visible,
              "account-set": _vm.accountSet,
              "current-state": _vm.dateSelecterDialog.currentState,
              "biz-data-type": _vm.dateSelecterDialog.bizDataType,
              "non-group-data": _vm.dateSelecterDialog.nonGroupData,
              "show-account-set-select":
                _vm.dateSelecterDialog.showAccountSetSelect,
              "office-id": _vm.dateSelecterDialog.officeId,
              "generate-type": _vm.generateType
            },
            on: {
              select: _vm.selectDataHandler,
              groupCommit: _vm.selectDataHandler,
              cancel: function() {
                return (_vm.dateSelecterDialog.visible = false)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }